import { useEffect, useState } from 'react';

interface VercelEnvironment {
  environment: string;
  isPreview: boolean;
  isProduction: boolean;
  isProtected: boolean;
}

const fallback: VercelEnvironment = {
  environment: 'local',
  isPreview: false,
  isProduction: false,
  isProtected: false,
};

let cached: VercelEnvironment | null = null;

export function useEnvironment(): VercelEnvironment {
  const [env, setEnv] = useState<VercelEnvironment>(cached ?? fallback);

  useEffect(() => {
    if (cached) return;

    let cancelled = false;
    fetch('/api/environment')
      .then((res) => {
        if (!res.ok) throw new Error(`status ${res.status}`);
        return res.json();
      })
      .then((data: VercelEnvironment) => {
        cached = data;
        if (!cancelled) setEnv(data);
      })
      .catch(err => {
        console.error("While calling vercel function", err)
        // Keep fallback on failure (e.g. local dev without the endpoint)
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return env;
}
